export const SET_DOCUMENTS = 'SET_DOCUMENTS';
export const SET_DOCUMENTS_SIGNING = 'SET_DOCUMENTS_SIGNING';
export const SET_LEGAL_DOCUMENTS = 'SET_LEGAL_DOCUMENTS';
